import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { UsuarioService } from '../../../providers/usuario.service';
import { Clasificacion } from '../../../interfaces/clasificacion';


@Component({
  selector: 'app-examen',
  templateUrl: './examen.component.html',
  styleUrls: ['./examen.component.scss']
})
export class ExamenComponent implements OnInit {
  @Input() cursoData: any = null;

  // usuarios: any[] = [];
  examen: Clasificacion;


  @Output() onContactoInput = new EventEmitter(); // datos del formulario cambian
  @Output() formState = new EventEmitter(); // emite el estado del formulario

  nombreFormControl = new FormControl('', [
    Validators.required
  ]);

  constructor(
    private usuarioService: UsuarioService
  ) { }

  ngOnInit(): void {
    console.log(this.cursoData);

    if (this.cursoData) {
      console.log(this.cursoData);
      this.examen = new Clasificacion(
        this.cursoData.id,
        this.cursoData.descripcion,
        this.cursoData.estado_tipo_contacto
      );
    } else {
      this.examen = new Clasificacion();
    }
  }


  onInput(): void { // cuando cambia un dato del formulario emitimos un evento
    this.onContactoInput.emit();
  }

  getPais(): Clasificacion {
    if (this.nombreFormControl.hasError('required')) {
      // marcar inputs como usados para mostrar el error si es necesario
      this.nombreFormControl.markAsTouched();
      throw "Datos incorrectos";
    }

    return this.examen;
  }
}